import { useEffect, useState } from 'react';
import LogoImg from '../../../assets/logo-high.png';
import { GetTemplates } from '../../../utils/api';
import { message } from 'antd';
import Loader from '../../shared/Loader';

const PushTemplates = () => {
    const [loading, setLoading] = useState(false);
    const [templates, setTemplates] = useState([]);

    const getTemplates = async () => {
        let params = 'type=notification';
        try {
            setLoading(true);
            const response = await GetTemplates(params);
            if (response?.isSuccess) {
                setTemplates(response?.items);
            }
        } catch (error) {
            message.error('Error while getting data, Try again later');
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getTemplates();
    }, []);

    if (loading) {
        return <Loader />
    }

    return (
        <section className='templets-card p-6 poppins'>
            <div className='grid grid-cols-3 gap-6' >
                {
                    templates && templates.map(template => {
                        return (
                            <div key={template.id} className='box-shadow p-4 flex flex-col gap-y-2 rounded-2xl'>
                                <div className="flex items-center gap-x-1 px-2">
                                    <img src={LogoImg} alt="logo-img" className='w-5 h-5 object-contain flex-shrink-0' />
                                    <span className='text-sm font-thin'>Beauty Spot</span>
                                </div>
                                <div className='px-2 pt-1'>
                                    <p className='text-sm font-semibold leading-tight mb-1'>{template?.title}</p>
                                    <div className='w-full'>
                                        <p className='text-xs'>{template?.body}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }

            </div>
        </section>
    )
}

export default PushTemplates;